import React from "react";
import {FormGroup, Label, FormText, Input, FormFeedback} from 'reactstrap'
import Select from 'react-select'
import {SelectOptionInterface} from "../../../interfaces/SelectOptionInterface";

interface Props {
    value: string|any,
    options: Array<SelectOptionInterface>,
    onChange: Function|any,
    error?: string|any,
    placeholder?: string|any,
    isMulti?: boolean,
    label?: string|any,
    isDisabled?: boolean|any,
    /** Render dropdown in document.body — use inside accordions/modals */
    menuPortal?: boolean,
}

const QSelect: React.FC<Props> = ({
    label,
    value,
    options = [],
    onChange,
    placeholder = '',
    error = '',
    isMulti= false,
    isDisabled = false,
    menuPortal = false,
}) => {

    const portalTarget = menuPortal && typeof document !== 'undefined' ? document.body : undefined;
    const isEmptyValue = value === null || value === undefined || value === '';
    const selectedOption = isEmptyValue
        ? null
        : options.find((option) => option.value == value) ?? null;

    return (
        <div className="mb-3">
            { label ? (
                <Label>
                    { label }
                </Label>
            ) : null }
            <Select
                className={'QSelectCustom'}
                isDisabled={isDisabled}
                isMulti={isMulti}
                placeholder={placeholder}
                menuPortalTarget={portalTarget}
                styles={menuPortal ? {
                    menuPortal: (base) => ({...base, zIndex: 9999}),
                } : undefined}
                onChange={(event: Event|any) => {
                    if(onChange) onChange(event);
                }}
                options={options}
                value={selectedOption}
            />
            { error ? (
                <FormFeedback>
                    { error }
                </FormFeedback>
            ) : null }

        </div>
    )
}

export default React.memo(QSelect);
